import React from "react";
import { tokens } from "../../theme";
import { Box, Typography, useTheme } from "@mui/material";

const StatBox = ({ title, subtitle, icon, progress, increase, iconBg }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	return (
		<Box
			width="100%"
			sx={{
				backgroundColor: theme.palette.mode === "dark" ? colors.primary[400] : "#FFFFFF",
				borderRadius: "16px",
				padding: "24px",
				border: `1px solid ${theme.palette.mode === "dark" ? colors.primary[300] : colors.grey[200]}`,
				boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
				transition: "all 0.2s ease-in-out",
				cursor: "pointer",
				"&:hover": {
					boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
					borderColor: colors.greenAccent[500],
				}
			}}
		>
			<Box display="flex" justifyContent="space-between" alignItems="flex-start" mb="16px">
				<Box
					sx={{
						backgroundColor: iconBg || colors.greenAccent[500],
						padding: "12px",
						borderRadius: "12px",
						boxShadow: `0 10px 15px -3px ${iconBg || colors.greenAccent[500]}4D`, // 30% opacity
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						color: theme.palette.mode === "dark" ? colors.primary[500] : colors.primary[100],
					}}
				>
					{icon}
				</Box>
				<Typography
					variant="h6"
					sx={{
						color: colors.greenAccent[500] || colors.greenAccent[600],
						fontWeight: "600",
						fontSize: "14px"
					}}
				>
					{increase}
				</Typography>
			</Box>

			<Typography
				variant="h3"
				fontWeight="bold"
				sx={{ color: colors.grey[100], mb: "4px" }}
			>
				{title}
			</Typography>

			<Typography
				variant="h6"
				sx={{
					color: colors.grey[500],
					fontWeight: "500",
					fontSize: "14px"
				}}
			>
				{subtitle}
			</Typography>
		</Box>
	);
};

export default StatBox;
